var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"wrapper"},[_c('SideBar'),_c('div',{staticClass:"main-panel"},[_c('Header'),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('Footer')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }